import _ from 'lodash';
import { fetchStudentRollNoApi } from '../../../apis/rollNoUpdate';
import { RollNoData } from '../types/rollNoDataType';

const transformResponse = (allData: any[]) => {
  const result = allData.map((data) => ({
    name: data.student.name,
    enrollmentNo: data.student.enrollmentNo,
    rollNo: data.student.rollNo,
    id: data.student.id,
    email: data.student.email,
    status: data.student.status,
    profile: data.student.profile,
    gender: data.student.gender
  }));
  return result;
};

export const fetchAllStudentRollNo = async (params: any) => {
  const perPage = 400;
  let pageNo = 1;
  let allData: any[] = [];
  while (true) {
    const response = await fetchStudentRollNoApi(params, pageNo, perPage);
    const pageData = response || [];
    if (_.isEmpty(pageData)) break;
    allData = allData.concat(pageData);
    pageNo++;
  }
  return transformResponse(allData);
};

export const getLastName = (name?: string, school?: string) => {
  if (school === 'BPIS') {
    return (name || '').trim().toLowerCase();
  }
  const tokens = (name || '').trim().split(' ').filter(Boolean);

  if (!tokens.length) {
    return '';
  }
  
  return tokens[tokens.length - 1].toLowerCase();
};

export const sortStudentsByLastName = (
  firstStudent: RollNoData,
  secondStudent: RollNoData,
  school?: string
) => {
  return getLastName(firstStudent.name, school).localeCompare(
    getLastName(secondStudent.name, school)
  );
};

const SortOrder = {
  NEUTRAL: 0,
  ASCENDING: 1,
  DESCENDING: -1
};

export const sortStudentsByRollNo = (
  firstRollNo: number | string | undefined,
  secondRollNo: number | string | undefined
) => {
  const firstRollNoVal = (firstRollNo?.toString() || '').trim();
  const secondRollNoVal = (secondRollNo?.toString() || '').trim();

  if (!firstRollNoVal || !secondRollNoVal) {
    if (firstRollNoVal === secondRollNoVal) {
      return SortOrder.NEUTRAL;
    }
    if (!firstRollNoVal) {
      return SortOrder.ASCENDING;
    }
    return SortOrder.DESCENDING;
  }

  const parseFirstRollNo = parseInt(firstRollNoVal, 10);
  const parseSecondRollNo = parseInt(secondRollNoVal, 10);

  if (isNaN(parseFirstRollNo) || isNaN(parseSecondRollNo)) {
    return firstRollNoVal.localeCompare(secondRollNoVal);
  }

  return parseFirstRollNo - parseSecondRollNo;
};

export const assignRollNumbersToStudents = (
  studentsList: RollNoData[],
  rollNumber: string
): RollNoData[] => {
  const rollNumberStartsWithZero = rollNumber.startsWith('0');
  let nextRollNumberValue = parseInt(rollNumber, 10);

  return studentsList.map((student) => {
    let generatedRollNumber = nextRollNumberValue.toString();
    if (rollNumberStartsWithZero) {
      generatedRollNumber = generatedRollNumber.padStart(
        rollNumber.length,
        '0'
      );
    }
    nextRollNumberValue++;
    return { ...student, rollNo: generatedRollNumber };
  });
};
